module.exports = __webpack_public_path__ + "img/P26-zh.d7efd1b1.png";